export function initUpcomingWorkations() {
  //reducing opacity for all CLOSED booking states 
  document.querySelectorAll("#upcoming-workations .swiper-slide").forEach(item => {
    let bookingState = item.getAttribute("data-booking-state")?.toLowerCase();
    if (bookingState === "closed") {
      item.style.opacity = "0.5";
      item.style.pointerEvents = "none";
			item.style.cursor = "not-allowed";
    } else if (bookingState === "available soon") {
      item.style.pointerEvents = "none";
      item.style.cursor = "default";
    }
  });
}
